import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { change } from 'redux-form';
// import styled from '@emotion/styled';
import { Divider } from '@mui/material';

import RadioField from 'shared/components/radio-field';
import CheckboxField from 'shared/components/checkbox-field';
import SelectField from 'shared/components/select-field';
import UploadField from 'shared/components/upload-field';
import TextField from 'shared/components/text-field';
import NumberField from "shared/components/number-field";
import DateField from "shared/components/date-field";
import DateRangeField from "shared/components/date-range-field";
import EmailField from "shared/components/email-field";
import PhoneField from "shared/components/phone-field";
import ComboboxField from "shared/components/combobox-field";
import StarRating from "shared/components/star-rating";
import NumberRange from "shared/components/number-range";
import SwitchField from "shared/components/switch-field";
import UploadImageField from "shared/components/image-upload-field";
import EmojiRating from "shared/components/emoji-rating";
import MultiInput from "shared/components/multi-input";
import ImageSelector from "../image-select-field/ImageSelector";
import SelectImageField from "../image-select-field";
import GridField from "shared/components/grid-field";
import InfoField from "shared/components/info-field";

const EXT_MIME = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  bmp: 'image/bmp',
};

// Appends `width: ...;height: ...` from stored media dimensions, normalizing
// bare numbers to px. Returns '' when neither is set.
const dimensionStyle = (width, height) => {
  const norm = (v) => {
    if (v == null || v === '') return null;
    const s = String(v).trim();
    return /^\d+(\.\d+)?$/.test(s) ? `${s}px` : s;
  };
  const parts = [];
  const w = norm(width);
  const h = norm(height);
  if (w) parts.push(`width: ${w}`);
  if (h) parts.push(`height: ${h}`);
  return parts.join(';');
};

// Replaces each bare `"<fileName>"` token in the question label with an inline
// <img> built from the matching QUESTION_IMAGE media entry's base64 blobValue,
// applying the width/height set in the admin editor (kept responsive via max-width).
const renderLabelWithMedia = (html, media) => {
  if (!html || !Array.isArray(media)) return html;
  let result = html;
  for (const m of media) {
    if (m?.mediaType !== 'QUESTION_IMAGE' || !m.fileName || !m.blobValue) continue;
    const ext = (m.fileName.split('.').pop() || '').toLowerCase();
    const src = m.blobValue.startsWith('data:')
      ? m.blobValue
      : `data:${EXT_MIME[ext] || 'image/png'};base64,${m.blobValue}`;
    const dims = dimensionStyle(m.width, m.height);
    const style = dims ? `max-width:100%;${dims}` : 'max-width:100%';
    result = result.split(`"${m.fileName}"`).join(`<img src="${src}" style="${style}" />`);
  }
  return result;
};

const GenericField = (props) => {

  if (props.typeName === 'RADIO') {
    return <RadioField {...props} />
  } else if (props.typeName === 'CHECKBOX') {
    return <CheckboxField {...props} />
  } else if (props.typeName === 'SELECT') {
    return <SelectField {...props} />
  } else if (props.typeName === 'FILE') {
    return <UploadField {...props} />
  } else if (props.typeName === 'IMAGE-SELECT') {
    return <SelectImageField {...props} />
  } else if (props.typeName === 'NUMBER') {
    return <NumberField {...props} />
  } else if (props.typeName === 'DATE') {
    return <DateField {...props} />
  } else if (props.typeName === 'PERIOD') {
    return <DateRangeField {...props} />
  } else if (props.typeName === 'EMAIL') {
    return <EmailField {...props} />
  } else if (props.typeName === 'PHONE') {
    return <PhoneField {...props} />
  } else if (props.typeName === 'COMBOBOX') {
    return <ComboboxField {...props} />
  } else if (props.typeName === 'STAR-RATING') {
    return <StarRating {...props} />
  } else if (props.typeName === 'NUMBER-RANGE') {
    return <NumberRange {...props} />
  } else if (props.typeName === 'SWITCH') {
    return <SwitchField {...props} />
  } else if (props.typeName === 'EMOJI-RATING') {
    return <EmojiRating {...props} />
  } else if (props.typeName === 'MULTI-INPUT') {
    return <MultiInput {...props} />
  } else if (props.typeName === 'GRID') {
    return <GridField {...props} />
  } else if (props.typeName === 'INFO') {
    return <InfoField {...props} />
  }

  return (
    <TextField {...props} />
  )
}

const GenericFieldWrapper = (props) => {
  const { name, visibility, language, attributes, fieldState, change, showDivider } = props;

  // const [options, setOptions] = useState([]);

  // useEffect(() => {
  //   console.log('GenericField useEffect', name, visibility);
  // }, []);


  useEffect(() => {
    // console.log('GenericField visibility', name, visibility);
    if (visibility === 'hidden') {
      change('survey', name, null);
    }
  }, [visibility]);

  // useEffect(() => {
  //   console.log(
  //     'GenericField attributes',
  //     name,
  //     visibility,
  //     JSON.parse(JSON.stringify(attributes)),
  //     JSON.parse(JSON.stringify(options)),
  //     JSON.parse(JSON.stringify(fieldState))
  //   );

  //   const newOptions = attributes?.map(attr => {
  //     const newAttr = { ...attr }
  //     if (newAttr?.label?.[language]) {
  //       newAttr.label = newAttr.label?.[language];
  //     }
  //     return newAttr;
  //   });
  //   setOptions([...newOptions]);
  //   // setOptions([...attributes]);
  // }, [attributes]);

  return (
    <div>
      {/* {props.id} - {props.order} - {props.label} - {visibility} - {JSON.stringify(fieldState)} */}
      {(visibility === 'visible') &&
        <div key={name}>
          {/* <h3>{<i>{props.label}</i>}</h3> */}
          <h3 dangerouslySetInnerHTML={{ __html: renderLabelWithMedia(props.label, props.media) }}></h3>
          <GenericField
            {...props}
            // options={options}
            // options={attributes}
            options={attributes?.map(attr => {
              const newAttr = { ...attr }
              if (newAttr?.label) {
                if (!language) {
                  newAttr.label = '';
                  return newAttr;
                }
                newAttr.label = newAttr.label?.[language];
              }

              return newAttr;
            })}
          />
          {/* {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))} */}
          <br />
          {showDivider && <Divider />}
        </div>
      }
    </div>
  );
}

const mapDispatchToProps = {
  change
};


const GenericFieldConnected = connect(
  null, //mapStateToProps,
  mapDispatchToProps
)(GenericFieldWrapper)


export default GenericFieldConnected;